<template>
  <div class="data-view">
    <dv-full-screen-container>
      <div class="header-container">
        <div class="title">
          <div class="title__left"></div>
          <div class="title__text">安全体系建设可视化面板</div>
          <div class="title__right"></div>
        </div>
        <div class="version">数据来源：{{ jiChuXinXi?.name }}</div>
        <div class="current-time">当前时间：{{ currentTime }}</div>
      </div>
      <div class="main-container">
        <div class="left-container">
          <div class="hazard-overview-container">
            <hazard-overview/>
          </div>
          <div class="hidden-danger-quality-chart-container">
            <hidden-danger-quality-chart/>
          </div>
          <div class="hidden-danger-quality-district-chart-container">
            <hidden-danger-quality-district-chart/>
          </div>
        </div>
        <div class="center-container">
          <div class="flyline-chart-container">
            <flyline-chart/>
          </div>
          <div class="basic-info-container">
            <basic-info/>
          </div>
          <div class="other-info-container">
            <other-info/>
          </div>
        </div>
        <div class="right-container">
          <div class="recent-activity-container">
            <recent-activity/>
          </div>
          <div class="overall-progress-container">
            <overall-progress/>
          </div>
          <div class="rectification-chart-container">
            <rectification-chart/>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>
<script>
import HazardOverview from '@/components/YinHuanShiJianGaiKuang/index.vue'
import BasicInfo from '@/components/JianYao/index.vue'
import FlylineChart from '@/components/DiTu/index.vue'
import HiddenDangerQualityChart from '@/components/YinHuanShuLiangLeiBieFenBu/index.vue'
import HiddenDangerQualityDistrictChart from '@/components/YinHuanShuLiangQuYuFenBu/index.vue'
import RecentActivity from '@/components/ZuiJinDongTai/index.vue'
import RectificationChart from '@/components/YinHuanZhengGaiQingKuang/index.vue'
import OverallProgress from '@/components/YinHuanJingGaoJiBieFenBu/index.vue'
import OtherInfo from '@/components/QiTaXinXi/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    HazardOverview,
    BasicInfo,
    FlylineChart,
    HiddenDangerQualityChart,
    HiddenDangerQualityDistrictChart,
    RecentActivity,
    RectificationChart,
    OverallProgress,
    OtherInfo
  },
  data () {
    return {
      jiChuXinXi: null,
      currentTime: '00:00:00',
      timer: null
    }
  },
  created () {
    this.getJiChuXinXi()
  },
  methods: {
    async getJiChuXinXi () {
      const res = await request.get('/common/ji-chu-xin-xi')
      this.jiChuXinXi = res.data
    },
    updateTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')

      this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`
    }
  },
  mounted () {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss" scoped>
.data-view {
  height: 100%;
  //background-color: #081035;
  background-image: url('@/assets/app-background-img.jpg');
}

#dv-full-screen-container {
  padding: 32px;
}

.header-container {
  position: relative;
  height: 10%;

  .title {
    display: flex;

    .title__left {
      flex-grow: 1;
      background-image: url('@/assets/head_bg_left.png');
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: right;
    }

    .title__text {
      color: #fff;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 28px;
      background-image: url('@/assets/head_bg_center.png');
      background-size: auto 100%;
    }

    .title__right {
      flex-grow: 1;
      background-image: url('@/assets/head_bg_right.png');
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: left;
    }
  }

  .version {
    position: absolute;
    color: #fff;
    top: 50%;
    left: 15%;
    transform: translateY(-50%);
  }

  .current-time {
    position: absolute;
    color: #fff;
    top: 50%;
    right: 15%;
    transform: translateY(-50%);
  }
}

.main-container {
  height: 90%;
  display: flex;

  .left-container {
    height: 100%;
    width: 25%;

    .hazard-overview-container {
      margin-bottom: 16px;
      height: 30%;
    }

    .hidden-danger-quality-chart-container {
      margin-bottom: 16px;
      height: 30%;
    }

    .hidden-danger-quality-district-chart-container {
      height: calc(100% - 16px - 16px - 30% - 30%);
    }
  }

  .center-container {
    height: 100%;
    width: 50%;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-direction: column;

    .flyline-chart-container {
      height: 60%;
    }

    .basic-info-container {
    }

    .other-info-container {
      flex-grow: 1;
    }
  }

  .right-container {
    height: 100%;
    width: 25%;

    .recent-activity-container {
      height: 30%;
      margin-bottom: 16px;
    }

    .overall-progress-container {
      height: 30%;
      margin-bottom: 16px;
    }

    .rectification-chart-container {
      height: calc(100% - 16px - 16px - 30% - 30%);
      margin-bottom: 16px;
    }
  }
}
</style>
